var map = {
	"./": 41528,
	"./Admins.messages": 51723,
	"./Admins.messages.js": 51723,
	"./Common/Admin-config.json5": 52972,
	"./Common/CommonRouting": 23137,
	"./Common/CommonRouting.js": 23137,
	"./Components/NotificationList/NotificationList": 2430,
	"./Components/NotificationList/NotificationList.jsx": 2430,
	"./Components/NotificationList/NotificationList.metadata.json5": 58523,
	"./Components/NotificationList/NotificationList.module.scss": 24043,
	"./Components/RIUserEdit/RIUserEdit": 42340,
	"./Components/RIUserEdit/RIUserEdit.jsx": 42340,
	"./Components/RIUserEdit/RIUserEdit.messages": 85993,
	"./Components/RIUserEdit/RIUserEdit.messages.js": 85993,
	"./Components/RIUserEdit/RIUserEdit.metadata.json5": 27737,
	"./Components/RIUserEdit/RIUserEdit.module.scss": 85649,
	"./Components/RIUserList/RIUserList": 65444,
	"./Components/RIUserList/RIUserList.jsx": 65444,
	"./Components/RIUserList/RIUserList.messages": 70645,
	"./Components/RIUserList/RIUserList.messages.js": 70645,
	"./Components/RIUserList/RIUserList.metadata.json5": 97473,
	"./Components/RIUserList/RIUserList.module.scss": 82097,
	"./Notification.messages": 60670,
	"./Notification.messages.js": 60670,
	"./index": 41528,
	"./index.js": 41528,
	"./package": 62271,
	"./package.json": 62271,
	"./pages/AdminLanding/AdminLanding": 74442,
	"./pages/AdminLanding/AdminLanding.jsx": 74442,
	"./pages/AdminLanding/AdminLanding.metadata.json5": 83147,
	"./pages/AdminLanding/AdminLanding.module.scss": 61311,
	"./pages/ManageRIUsers/ManageRIUsers": 40352,
	"./pages/ManageRIUsers/ManageRIUsers.jsx": 40352,
	"./pages/ManageRIUsers/ManageRIUsers.messages": 29415,
	"./pages/ManageRIUsers/ManageRIUsers.messages.js": 29415,
	"./pages/ManageRIUsers/ManageRIUsers.metadata.json5": 38785,
	"./pages/ManageRIUsers/ManageRIUsers.module.scss": 37797,
	"./pages/MyNotifications/MyNotifications": 13744,
	"./pages/MyNotifications/MyNotifications.jsx": 13744,
	"./pages/MyNotifications/MyNotifications.metadata.json5": 57985,
	"./pages/MyNotifications/MyNotifications.module.scss": 76021,
	"./pages/RIBillingDelivery/RIBillingDeliveryComponent": 92939,
	"./pages/RIBillingDelivery/RIBillingDeliveryComponent.jsx": 92939,
	"./pages/RIBillingDelivery/RIBillingDeliveryComponent.messages": 366,
	"./pages/RIBillingDelivery/RIBillingDeliveryComponent.messages.js": 366,
	"./pages/RIBillingDelivery/RIBillingDeliveryComponent.metadata.json5": 4920,
	"./pages/RIBillingDelivery/RIBillingDeliveryComponent.module.scss": 97318,
	"./pages/mypolicy/MyPolicyFrame": 37559,
	"./pages/mypolicy/MyPolicyFrame.jsx": 37559,
	"./pages/mypolicy/MyPolicyFrame.metadata.json5": 74112,
	"./pages/mypolicy/MyPolicyFrame.module.scss": 52989,
	"./pages/profile/ProfileManager": 77791,
	"./pages/profile/ProfileManager.jsx": 77791,
	"./pages/profile/ProfileManager.metadata.json5": 60836,
	"./pages/profile/ProfileManager.module.scss": 30802,
	"./pages/users/UserManager": 21382,
	"./pages/users/UserManager.jsx": 21382,
	"./pages/users/UserManager.metadata.json5": 51383,
	"./pages/users/UserManager.module.scss": 93171,
	"./utils/RIBillingDeliveryUtil": 71622,
	"./utils/RIBillingDeliveryUtil.js": 71622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81202;